import React from "react";
import {
  Box,
  Paper,
  Select,
  Typography,
  InputLabel,
  MenuItem,
  FormControl,
  TextField,
  CircularProgress,
} from "@mui/material";
import OpenWithIcon from '@mui/icons-material/OpenWith';

function SmokingChart({ smokingChartData, page, title, idealValue, handleOpen, settingType }) {
  const width = page === "Lifestyle" ? "85%" : "100%";
  const graphPadding = page === "Lifestyle" ? 2 : 0;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        // flex: 1,
        width: page === "Lifestyle" ? { xl:"85%", xl:'85%', md:'60%'} : '100%'
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignContent: 'space-between' }}>
        <Typography
          variant="p"
          align="left"
          sx={{ marginLeft: 2, fontSize: "15px", fontWeight: "bold", }}
        >
          {title
            ?.toLowerCase()
            .split("_")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ")}
        </Typography>

        {handleOpen && <OpenWithIcon onClick={() => {
          handleOpen()
          settingType(title)
        }} sx={{ alignSelf: 'flex-end', right: 20, cursor: 'pointer', fontSize: 'medium' }} />}
      </Box>

      <Typography variant="p" align="right" fontSize={ page === "Lifestyle" ?  "9px"  :handleOpen ? "9px" : "13px"} mt={1}>
        Ideal - {idealValue}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          flex: 1,
          width:{xl: "100%", lg:'100%', md:'88%'},
          p: graphPadding,
          fontSize: "8px",
          gap: 1,
          justifyContent: page == "Lifestyle"?'flex-start': 'center',
          alignItems: "center",
           overflow:'auto'
        }}
      >
        {smokingChartData.map((data, index) => {
          if (data["answer"] >= 1) {
            return (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box
                  sx={{
                    height: handleOpen ? "58px" : page === "Lifestyle" ? "58px" : '178px',
                    width: handleOpen ? "8px" : page === "Lifestyle" ? '8px' : "15px",
                    backgroundColor: "#FF6445",
                    borderRadius: 10,
                    boxShadow: 3,
                    marginBottom: "5px",
                  }}
                ></Box>
                <Box display={"flex"}>
                  <Typography fontSize={handleOpen ? "8px" : page === "Lifestyle" ? "8px" : "13px"} sx={{fontWeight:'bold'}}>{data["week"]}</Typography>
                </Box>
              </Box>
            );
          } else if (data["answer"] === 0) {
            return (
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Box
                  sx={{
                    height: handleOpen ? "40px" : page === "Lifestyle" ? "40px" : '150px',
                    width: handleOpen ? "8px" : page === "Lifestyle" ? '8px' : "15px",
                    backgroundColor: "#C8EDF5",
                    borderRadius: 10,
                    boxShadow: 3,
                    marginBottom: "5px",
                  }}
                ></Box>
                <Box>
                  <Typography fontSize={handleOpen ? "8px" : page === "Lifestyle" ? "8px" : "13px"} sx={{fontWeight:'bold'}}>{data["week"]}</Typography>
                </Box>
              </Box>
            );
          } else {
            return (
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Box
                  sx={{
                    height: handleOpen ? "40px" : page === "Lifestyle" ? "40px" : '150px',
                    width: handleOpen ? "8px" : page === "Lifestyle" ? '8px' : "15px",
                    backgroundColor: "#b6c0c4ff",
                    borderRadius: 10,
                    boxShadow: 3,
                    marginBottom: "5px",
                  }}
                ></Box>
                <Box>
                  <Typography fontSize={handleOpen ? "8px" : page === "Lifestyle" ? "8px" : "13px"} sx={{fontWeight:'bold'}}>{data["week"]}</Typography>
                </Box>
              </Box>
            );
          }
        })}
      </Box>
    </Box>
  );
}

export default SmokingChart;
